var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cb-select-plus cb-validation-group",class:{ 'cb-select-plus--full-width': _vm.isFullWidth }},[_c('select',_vm._b({ref:"select"},'select',_vm.$attrs,false),[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }